import { useTranslation } from "next-i18next";

import { Flavor } from "@/ui/typography/Flavor";

/**
 * WHO-6509 (D7, D8). Under every US delivery block, quote or price: how long it takes, and that
 * import duties are the buyer's, collected by the carrier on delivery. Placeholder wording until
 * Sterre's (WHO-6521).
 */
export const UsDeliveryFacts = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1" data-testid="pdp.us-delivery.facts">
      <Flavor size="medium" className="font-bold">
        {t("pdp:pdp-us-delivery-weeks", {
          defaultValue: "Delivery in 4–8 weeks",
        })}
      </Flavor>
      <Flavor size="medium">
        {t("pdp:pdp-us-delivery-duties", {
          defaultValue:
            "US import duties and taxes are not included. The carrier collects them from you on delivery.",
        })}
      </Flavor>
    </div>
  );
};
